import { Scope1And2CategoryConfig } from './config';

/**
 * Importer copy for the Scope 1 & 2 flow. Mirrors the structure of the
 * food/packaging importer translations. Parameterised by the category so the
 * upload step names the section, and the multi-sheet picker tells the user
 * exactly which tab of the template to select.
 */
export const getScope1And2ImporterTranslations = (
  config: Scope1And2CategoryConfig
) => ({
  uploadStep: {
    title: `Upload your ${config.label.toLowerCase()} spreadsheet`,
    selectSheet: {
      title: `Select the "${config.sheetName}" sheet`,
    },
    manifestTitle: 'What data does it need to contain?',
    manifestDescription: (
      <div className="space-y-4 py-6">
        <p>
          Select the sheet for this category and make sure each value matches
          one of your platform records (sites, units, fuels, gases and time
          periods).
        </p>
        <p className="font-semibold">
          You can choose which column maps to each field in the next step.
        </p>
      </div>
    ),
  },
  matchColumnsStep: {
    title: 'Select the columns',
    userTableTitle: 'Your spreadsheet',
  },
  validationStep: {
    nextButtonTitle: 'Import data',
  },
  alerts: {
    submitError: {
      title: 'Failed importing data',
      defaultMessage: 'Please check your data and try again',
    },
  },
});
